import { detect } from 'detect-browser'

const { name, version, os } = detect()

export const browser = {
	isMS: false,
	name,
	version,
	os,
	checkBrowser() {
		//Try to find the Trident version number
		var trident = navigator.userAgent.match(/Trident\/(\d+)/)
		if (trident) {
			this.isMS = true
		}

		var msie = navigator.userAgent.match(/MSIE (\d+)/)
		if (msie) {
			this.isMS = true
		}

		//Try to find Edge and the EdgeHTML vesion number
		var edge = navigator.userAgent.match(/Edge\/(\d+\.\d+)$/)
		if (edge) {
			this.isMS = true
		}

		//If it's the new edge-chromium browser we'll let them roll through.
		if (detect().name === 'edge-chromium') {
			this.isMS = false
		}
	},
}

const mobileOS = ['iOS', 'Android OS', 'Amazon OS']
export const isMobileDevice = mobileOS.includes(os)
export const isSafari = browser.name === 'safari'
export const isFirefox = browser.name === 'firefox'
export const isChrome = browser.name === 'chrome'
